import React from 'react';
import { finishCluster } from '../../api/api.js';
import Row from './Row';

const Table = ({ cluster, checkExp, checkStand, setCheckExp, setCheckStand }) => {

  const handleCheckExp = async () => {
    await setCheckExp(true);
    await finishCluster(cluster.id);
  }

  const handleCheckStand = async () => {
    await setCheckStand(true);
    await finishCluster(cluster.id);
  }

  return (
    <div className="table">
      <table className="table is-bordered is-hoverable">
        <thead>
          <tr>
            <th>Zadatak</th>
            <th className="solution-button" onClick={() => handleCheckExp(true)}>Proveri</th>
            { checkExp ? <th>Rešenje</th> : undefined }
            <th className="solution-button" onClick={() => handleCheckStand(true)}>Proveri</th>
            { checkStand ? <th>Rešenje</th> : undefined }
          </tr>
        </thead>
        <tbody>
        {console.log('TABLE.JS', cluster.problems[0])}
          {cluster.problems.map((problem) =>
            <Row key={problem.id} id={problem.id} {...problem} {...{ checkExp, checkStand }} />
          )}
        </tbody>
      </table>
    </div>
  )
}

export default Table;
